const configParams = window.ConfigParams;

export default configParams;